import React from 'react';
import { Box, ResponsiveContext, Spinner } from 'grommet';

const LoadDetails = () => {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          direction='column'
          align='center'
          justify='center'
          margin={{ top: 'medium' }}
          height='100vh'
        >
          <Box
            align='center'
            width='medium'
            pad={ size === 'small' ? 'large' : 'small' }
          >
            <Spinner size='medium' />
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export default LoadDetails;
